var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyMembers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.584,
    height: 28.216,
    viewBox: "0 0 29.584 28.216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2847",
    "data-name": "Groupe 2847",
    transform: "translate(-228.897 291)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_766",
    "data-name": "Groupe 766",
    transform: "translate(235.519 -291)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_88",
    "data-name": "Ellipse 88",
    transform: "translate(4.34 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1764",
    "data-name": "Trac\\xE9 1764",
    d: "M-536.865,390.655a7.149,7.149,0,0,1-7.141-7.14,7.15,7.15,0,0,1,7.141-7.141,7.149,7.149,0,0,1,7.14,7.141A7.148,7.148,0,0,1-536.865,390.655Zm0-12.052a4.918,4.918,0,0,0-4.913,4.912,4.917,4.917,0,0,0,4.913,4.911,4.917,4.917,0,0,0,4.911-4.911A4.917,4.917,0,0,0-536.865,378.6Z",
    transform: "translate(544.006 -376.374)",
    fill: "#3e3e3e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trac\\xE9_390",
    "data-name": "Trac\\xE9 390",
    transform: "translate(0 15.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1765",
    "data-name": "Trac\\xE9 1765",
    d: "M-532.071,413.752h-14.866a4.042,4.042,0,0,1-3.346-1.772,4.049,4.049,0,0,1-.417-3.77,11.976,11.976,0,0,1,11.2-7.609,11.978,11.978,0,0,1,11.2,7.609,4.049,4.049,0,0,1-.417,3.77A4.042,4.042,0,0,1-532.071,413.752ZM-539.5,402.83a9.758,9.758,0,0,0-9.124,6.2,1.8,1.8,0,0,0,.187,1.7,1.8,1.8,0,0,0,1.5.8h14.866a1.8,1.8,0,0,0,1.5-.8,1.8,1.8,0,0,0,.187-1.7,9.759,9.759,0,0,0-9.124-6.2Z",
    transform: "translate(550.985 -400.601)",
    fill: "#3e3e3e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_766-2",
    "data-name": "Groupe 766",
    transform: "translate(228.897 -286.541)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_88-2",
    "data-name": "Ellipse 88",
    transform: "translate(3.654 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1764-2",
    "data-name": "Trac\\xE9 1764",
    d: "M-537.993,388.4a6.019,6.019,0,0,1-6.013-6.011,6.019,6.019,0,0,1,6.013-6.013,6.019,6.019,0,0,1,6.011,6.013A6.018,6.018,0,0,1-537.993,388.4Zm0-10.148a4.141,4.141,0,0,0-4.136,4.136,4.14,4.14,0,0,0,4.136,4.135,4.14,4.14,0,0,0,4.135-4.135A4.14,4.14,0,0,0-537.993,378.25Z",
    transform: "translate(544.006 -376.374)",
    fill: "#3e3e3e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trac\\xE9_390-2",
    "data-name": "Trac\\xE9 390",
    transform: "translate(0 12.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1765-2",
    "data-name": "Trac\\xE9 1765",
    d: "M-535.06,411.673h-12.517a3.4,3.4,0,0,1-2.817-1.492,3.409,3.409,0,0,1-.351-3.174,10.083,10.083,0,0,1,9.427-6.407,10.085,10.085,0,0,1,9.427,6.407,3.409,3.409,0,0,1-.351,3.174A3.4,3.4,0,0,1-535.06,411.673Zm-6.259-9.2A8.216,8.216,0,0,0-549,407.7a1.514,1.514,0,0,0,.157,1.428,1.511,1.511,0,0,0,1.267.67h12.517a1.511,1.511,0,0,0,1.266-.67,1.514,1.514,0,0,0,.157-1.428,8.217,8.217,0,0,0-7.682-5.221Z",
    transform: "translate(550.985 -400.601)",
    fill: "#3e3e3e"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyMembers);
export default __webpack_public_path__ + "static/media/MyMembers.c561b79c6f335b16245f833487726761.svg";
export { ForwardRef as ReactComponent };